var map = {
	"./error/error.module.ngfactory": [
		"./src/app/error/error.module.ngfactory.js",
		"error-error-module-ngfactory"
	],
	"./logclaude/logclaude.module.ngfactory": [
		"./src/app/logclaude/logclaude.module.ngfactory.js",
		"logclaude-logclaude-module-ngfactory"
	],
	"./login/login.module.ngfactory": [
		"./src/app/login/login.module.ngfactory.js",
		"login-login-module-ngfactory"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;